import Joi from 'joi';

export default Joi.object({
	price: Joi.number()
		.integer()
		.min(1)
		.error(() => ({
			message: 'Kupní cena nemovitosti musí být celé kladné číslo.',
		})),
	years: Joi.number()
		.integer()
		.min(1)
		.max(30)
		.error(() => ({
			message: 'Doba splatnosti musí být celé kladné číslo od 1 do 30.',
		})),
	income: Joi.number()
		.integer()
		.min(0)
		.error(() => ({
			message: 'Čistý měsíční příjem musí být celé kladné číslo nebo 0.',
		})),
	payment: Joi.number()
		.integer()
		.min(0)
		.error(() => ({
			message: 'Měsíční splátky dluhů musí být celé kladné číslo nebo 0.',
		})),
	debt: Joi.number()
		.integer()
		.min(0)
		.error(() => ({
			message: 'Současný dluh celkem musí být celé kladné číslo nebo 0.',
		})),
});
